export default __webpack_public_path__ + "static/media/arrowdown.ff929b78.svg";